"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const TableRowContext_1 = require("@/components/DynamicTable/TableRowContext");
const components_1 = require("@/store/ducks/components");
const selectors_1 = require("@/store/ducks/components/selectors");
const deleteComponentsUseCase_1 = require("@/useCases/components/deleteComponentsUseCase");
const components_2 = require("@/services/components");
const index_view_1 = __importDefault(require("./index.view"));
function ComponentsDialogAlert() {
    const { arrayHelpers } = (0, TableRowContext_1.useTableRowContext)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isDeleting = (0, react_redux_1.useSelector)(selectors_1.isDeletingSelector);
    const deletionErrorMessage = (0, react_redux_1.useSelector)(selectors_1.errorMessageSelector);
    const isDialogVisible = (0, react_redux_1.useSelector)(selectors_1.isDeleteAlertDialogOpenSelector);
    const componentToBeDeleted = (0, react_redux_1.useSelector)(selectors_1.componentToBeDeletedSelector);
    const rowIndexToBeDeleted = (0, react_redux_1.useSelector)(selectors_1.rowIndexToBeDeletedSelector);
    const onClose = react_1.default.useCallback(() => {
        components_2.controller.abort();
        dispatch((0, components_1.closeDeleteComponentAlert)());
    }, [components_1.closeDeleteComponentAlert, components_2.controller]);
    const onProceed = react_1.default.useCallback(() => {
        (0, deleteComponentsUseCase_1.removeComponent)(componentToBeDeleted?.id)(dispatch).then(() => {
            arrayHelpers.remove(rowIndexToBeDeleted);
        }).catch(() => {
            return;
        });
    }, [arrayHelpers, rowIndexToBeDeleted, componentToBeDeleted, dispatch]);
    return (react_1.default.createElement(index_view_1.default, { isOpen: isDialogVisible, onClose: onClose, deletionErrorMessage: deletionErrorMessage, onDismiss: onClose, isDeleting: isDeleting, componentToBeDeleted: componentToBeDeleted?.name, onProceed: onProceed }));
}
exports.default = react_1.default.memo(ComponentsDialogAlert);
